import { createFileRoute } from "@tanstack/react-router";

import TodosExport from "@/features/todos/todos-export";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/eingang/export",
)({
  component: PayableExportPage,
  staticData: {
    breadcrumb: ["todos.payable.title"],
  },
});

function PayableExportPage() {
  return <TodosExport type="payable" />;
}
